export default __webpack_public_path__ + "static/media/notification.f71b52cf.svg";